<template>
  <div>
    <div id="label">Welcome</div>
    <button @click.prevent="login">Login</button>
    <button @click.prevent="logout">Logout</button>
    <button @click.prevent="token">token</button>
    <div>{{ loggedIn }}</div>
  </div>
</template>

<script>
import AuthService from "../auth/msal2-authService";

export default {
  name: "HelloWorld",
  data: () => {
    return {
      loggedIn: false,
    };
  },

  created() {
    // this.$msal.signIn();
    this.authService = new AuthService();
    this.login();
  },

  methods: {
    login: async function() {
      try {
        await this.authService.loginRedirect();
        this.loggedIn = true;
      } catch (error) {
        console.log(error);
      }
    },

    async logout() {
      await this.authService.logout();
    },

    async token() {
      await this.authService.getAccessToken();
    },
  },
};
</script>
